import { EntityInfoCard, useEntity } from '@backstage/plugin-catalog-react';
import { Flex } from '@backstage/ui';

import { azureSubscriptionsFromAnnotation } from './azureSubscriptionsAnnotation';
import { azureAppRegistrationsAnnotation } from './azureAppRegistrationsAnnotation';
import { AzureAppRegistrations } from './AzureAppRegistrations';
import { AzureSubscriptions } from './AzureSubscriptions';
import { hasAzureResources } from './hasAzureResources';

import styles from './AzureCard.module.css';

export const AzureCard = () => {
  const { entity } = useEntity();
  const appRegistrations = azureAppRegistrationsAnnotation(entity.metadata.annotations);
  const subscriptions = azureSubscriptionsFromAnnotation(entity.metadata.annotations);

  if (!hasAzureResources(entity.metadata.annotations)) {
    return null;
  }

  return (
    <EntityInfoCard title="Azure" className={styles.card}>
      <Flex direction="column" gap="3">
        <AzureSubscriptions subscriptions={subscriptions} />
        <AzureAppRegistrations appRegistrations={appRegistrations} />
      </Flex>
    </EntityInfoCard>
  );
};
